
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetomumbaiurbaniaonrent() {



  const cardData =
  {
    keyword: ' Pune to Mumbai Urbania on Rent',
    heading: 'Vaishnavi Travels: Pune to Mumbai Urbania on Rent',
    headingDescription: 'Vaishnavi Travels provides convenient and affordable Pune to Mumbai Urbania on Rent, perfect for family trips, weddings, corporate travel, and airport transfers. Our well-maintained Urbania comes with spacious push-back seating, strong air-conditioning, modern interiors, and ample luggage space, ensuring a smooth and comfortable journey on the Pune–Mumbai route. With experienced chauffeurs, punctual pickups, and flexible booking options, we make long-distance travel hassle-free and reliable. Whether it’s a business trip, weekend outing, or special occasion, Vaishnavi Travels guarantees safe, stylish, and comfortable Urbania rental services from Pune to Mumbai.',

    top: 'Top Places to Visit in Mumbai with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic landmark overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorated the visit of King George V and Queen Mary. Today, it is a bustling hub for tourists, photographers, and ferry rides to Elephanta Caves. The evening view, with the monument lit against the backdrop of the Taj Mahal Palace Hotel, is mesmerizing. Street vendors and performers add vibrancy to the spot. Gateway of India is Mumbai’s majestic symbol of pride and history."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also called the Queen’s Necklace, is a 3.6 km promenade along the Arabian Sea. Famous for its crescent-shaped streetlights resembling a glowing necklace at night, it is Mumbai’s most picturesque stretch. Locals enjoy jogging, relaxing, and watching stunning sunsets here. The monsoon brings dramatic sea waves that captivate visitors. It is also close to cultural hotspots like Chowpatty Beach. Marine Drive is Mumbai’s soul-soothing escape amidst city life."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, a UNESCO World Heritage Site located 11 km from Mumbai, are ancient rock-cut caves dedicated to Lord Shiva. The main highlight is the massive Trimurti sculpture, representing Shiva in three forms. Carved between the 5th and 8th centuries, the caves showcase India’s artistic brilliance. Accessible by ferry from the Gateway of India, the journey itself is scenic. The caves offer both history and spirituality. Elephanta is Mumbai’s timeless heritage treasure."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "Chhatrapati Shivaji Maharaj Terminus, a UNESCO World Heritage Site, is Mumbai’s grand Gothic Revival railway station built in 1887. Its domes, spires, stained glass, and carvings reflect Victorian and Indian architectural fusion. It is one of the busiest railway stations in India, yet also a tourist delight. At night, its illuminated façade is breathtaking. CSMT symbolizes Mumbai’s colonial past and modern vibrancy. It is the city’s living monument of heritage and connectivity."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, loved for its golden sands, lively atmosphere, and street food. Families, couples, and joggers gather here to enjoy sunsets and cool breezes. Vendors serve bhel puri, pav bhaji, and kulfi, making it a foodie’s paradise. Bollywood celebrities reside nearby, adding glamour to the area. Festivals and cultural events often take place here. Juhu Beach is Mumbai’s seaside hotspot for leisure and fun."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple, dedicated to Lord Ganesha, is Mumbai’s most revered spiritual site. Built in 1801, it attracts lakhs of devotees including celebrities and business leaders. The black stone idol of Ganesha, with its trunk curving to the right, is considered highly auspicious. Tuesdays are especially crowded with special darshan. The temple’s divine aura offers peace amidst the city’s chaos. Siddhivinayak is Mumbai’s beacon of faith and devotion."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, situated on an islet in the Arabian Sea, is one of Mumbai’s most iconic religious monuments. Built in 1431, it houses the tomb of Pir Haji Ali Shah Bukhari. The white marble mosque, connected by a narrow causeway, is a marvel during high tide. Thousands of devotees visit daily for blessings regardless of faith. Its setting amidst the sea is spectacular, especially during sunset. Haji Ali is Mumbai’s symbol of unity, faith, and harmony."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street, famous for fashion, jewelry, antiques, and handicrafts at bargain prices. It is also home to iconic cafés like Leopold Café and Café Mondegar. The lively street is filled with tourists, locals, and colorful displays. Heritage buildings add charm to the shopping experience. Street shopping here is a must-do for visitors. Colaba Causeway is Mumbai’s ultimate cultural and shopping hotspot."
  },
  {
    "title": "Chowpatty Beach",
    "description": "Chowpatty Beach, officially known as Girgaon Chowpatty, is a lively cultural hub in South Mumbai. It is famous for its Ganesh Visarjan celebrations where thousands gather every year. Street food stalls serve pav bhaji, bhel puri, and ice gola, making it a foodie’s delight. Families spend evenings here enjoying the festive vibe. The Arabian Sea backdrop enhances the experience. Chowpatty is Mumbai’s cultural seaside gathering spot."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park, spread over 100 sq km in North Mumbai, is one of the few national parks within a metropolitan city. It is home to leopards, deer, and hundreds of bird species. The park also houses the ancient Kanheri Caves, a group of Buddhist rock-cut structures. Visitors enjoy safaris, boating, and nature trails. Its greenery offers a refreshing contrast to Mumbai’s busy lifestyle. Sanjay Gandhi National Park is the city’s natural oasis of wildlife and heritage."
  }
],


   "services": [
    {
      "name": "Urbania Hire Pune to Mumbai",
      "description": "Book a comfortable and reliable Urbania van for your journey from Pune to Mumbai. Ideal for groups of 13 or 17, these vans offer spacious interiors and smooth rides on the highway. Whether for business trips or leisure travel, enjoy hassle-free transport with professional drivers familiar with the Pune-Mumbai route."
    },
    {
      "name": "Force Urbania for Mumbai Trip",
      "description": "Travel in style with the Force Urbania van for your Pune to Mumbai trip. This rugged and spacious vehicle is perfect for family outings, corporate groups, and tourists looking for comfort and safety. Equipped with modern amenities and experienced drivers, it ensures a pleasant journey."
    },
    {
      "name": "13/17 Seater Urbania Pune-Mumbai",
      "description": "Choose from 13 or 17 seater Urbania vans for group travel between Pune and Mumbai. These vehicles provide ample legroom, air conditioning, and luggage space, making them perfect for long-distance travel, group tours, and airport transfers."
    },
    {
      "name": "Outstation Urbania Pune to Mumbai",
      "description": "Plan your outstation trip from Pune to Mumbai with our Urbania vans offering reliable transportation for groups. Comfortable seating, on-time pickups, and professional drivers make your journey convenient whether it's a family vacation, corporate trip, or sightseeing tour."
    },
    {
      "name": "Corporate Urbania Pune to Mumbai",
      "description": "Opt for our Corporate Urbania services for business travel between Pune and Mumbai. Perfect for corporate staff commute, client visits, and business events, these vans ensure timely, professional, and comfortable transit for executives and teams."
    },
    {
      "name": "Pune to Mumbai Family Trip Urbania",
      "description": "Enjoy your family trip from Pune to Mumbai with our spacious Urbania vans. Designed for comfort and safety, these vans accommodate all family members with ample space for luggage and relaxing travel. Ideal for beach visits, city tours, and weekend getaways."
    },
    {
      "name": "Urbania Booking Pune for Mumbai Darshan",
      "description": "Book Urbania vans from Pune for Mumbai Darshan tours. Explore Mumbai’s iconic landmarks comfortably with group transport options including 13 and 17 seater vans equipped with AC and modern amenities for a memorable sightseeing experience."
    },
    {
      "name": "AC Urbania Travel Pune to Mumbai",
      "description": "Travel in cool comfort with our air-conditioned Urbania vans between Pune and Mumbai. These vehicles are equipped with advanced climate control systems, comfortable seating, and entertainment options, ensuring a pleasant journey even during summer months."
    },
    {
      "name": "Weekend Trip Urbania Van",
      "description": "Make your weekend trips from Pune to Mumbai hassle-free with our Urbania van rentals. Perfect for group outings, sightseeing, or short vacations, these vans provide flexible packages, door-to-door service, and experienced drivers to enhance your travel experience."
    },
    {
      "name": "Pune to Mumbai Luxury Urbania Van",
      "description": "Experience luxury travel between Pune and Mumbai with our premium Urbania vans. Featuring leather seats, soundproof cabins, and extra legroom, these vans are ideal for VIP travel, corporate executives, and special occasions requiring the best comfort and style."
    },
    {
      "name": "Mumbai Airport Drop Urbania Pune",
      "description": "Book Urbania vans for reliable and timely airport drop services from Pune to Mumbai Airport. Our drivers are punctual and familiar with airport protocols, ensuring a stress-free start or end to your journey with spacious luggage accommodation."
    },
    {
      "name": "Urbania Van for Mumbai Tour",
      "description": "Explore Mumbai with our Urbania vans designed for comfortable group tours. Whether visiting beaches, markets, or historic sites, our vans provide spacious seating, air conditioning, and professional drivers to make your Mumbai tour enjoyable and convenient."
    },
    {
      "name": "Pune-Mumbai Highway Urbania Rental",
      "description": "Rent Urbania vans optimized for highway travel between Pune and Mumbai. With smooth suspension, high ground clearance, and comfortable interiors, these vans provide safe and pleasant journeys on the busy Pune-Mumbai expressway."
    }
  ],
  "tableData": [
    ["Urbania Hire Pune to Mumbai", "Force Urbania for Mumbai Trip"],
    ["13/17 Seater Urbania Pune-Mumbai", "Outstation Urbania Pune to Mumbai"],
    ["Corporate Urbania Pune to Mumbai", "Pune to Mumbai Family Trip Urbania"],
    ["Urbania Booking Pune for Mumbai Darshan", "AC Urbania Travel Pune to Mumbai"],
    ["Weekend Trip Urbania Van", "Pune to Mumbai Luxury Urbania Van"],
    ["Mumbai Airport Drop Urbania Pune", "Urbania Van for Mumbai Tour"],
    ["Pune-Mumbai Highway Urbania Rental"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Urbania on Rent",
    "WhyChoosedescription": "Vaishnavi Travels provides comfortable and reliable Force Urbania rentals for the Pune to Mumbai route, perfect for group travel and corporate trips."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Seating",
    "WhyChoosedescription": "Our Urbania vans offer plush seats, ample legroom, and air conditioning to ensure a relaxing journey between Pune and Mumbai."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each vehicle is regularly serviced and thoroughly cleaned to provide a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Mumbai Route",
    "WhyChoosedescription": "Our professional drivers know the best routes and ensure timely, safe travel from Pune to Mumbai and back."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, full-day, or multi-day rental options tailored to your travel schedule and group size."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Our pricing includes fuel, tolls, driver allowance, and taxes for a hassle-free booking experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Travel, Family Trips, and Group Tours",
    "WhyChoosedescription": "Perfect for business trips, leisure travel, and group sightseeing between Pune and Mumbai."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, itinerary changes, and travel inquiries."
  }
]





















  }





const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer 13 seater Force Urbania on rent for Pune to Mumbai trips?',
      answer: 'Yes, Vaishnavi Travels provides 13 seater Force Urbania vehicles for rent on Pune to Mumbai routes, perfect for group travel, corporate transfers, and family trips between the two cities.',
    },
    {
      question: 'What are the key features of the 13 seater Force Urbania for Pune to Mumbai journeys?',
      answer: 'The 13 seater Force Urbania offers spacious seating, air-conditioning, comfortable legroom, modern interiors, and ample luggage space to ensure a comfortable and enjoyable ride on long-distance trips.',
    },
    {
      question: 'Are the vehicles and drivers reliable for Pune to Mumbai rentals?',
      answer: 'Absolutely! All vehicles are regularly serviced and maintained. Rentals include experienced and courteous drivers who are familiar with the Pune-Mumbai highway and can ensure a safe and timely journey.',
    },
    {
      question: 'What is the approximate rental cost for a Pune to Mumbai trip in a 13 seater Force Urbania?',
      answer: 'Rental costs for Pune to Mumbai trips usually start around ₹6,000, depending on trip duration, distance, and any additional services requested.',
    },
    {
      question: 'Can I book the 13 seater Force Urbania for return trips between Pune and Mumbai?',
      answer: 'Yes, Vaishnavi Travels offers flexible booking options for one-way or return trips between Pune and Mumbai with transparent pricing.',
    },
    {
      question: 'How early should I book a 13 seater Urbania for Pune to Mumbai travel?',
      answer: 'It is advisable to book at least 3 days in advance, especially during weekends and holiday seasons, to ensure vehicle availability.',
    },
    {
      question: 'Is flexible pickup and drop-off available for Pune to Mumbai Urbania rentals?',
      answer: 'Yes, flexible pickup and drop locations are provided within Pune, Mumbai, and nearby areas to suit your travel plans.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Suresh Patil",
    position: "Business Owner",
    feedback:
      "We rented a 13 seater Force Urbania from Vaishnavi Travels for our Pune to Mumbai business trip. The vehicle was comfortable and clean, and the driver was punctual and professional. Highly recommended!",
    rating: 5,
  },
  {
    name: "Ms. Kavita Sharma",
    position: "Travel Blogger",
    feedback:
      "The Pune to Mumbai journey in the 13 seater Urbania was smooth and pleasant. Spacious seating and good air-conditioning made the trip enjoyable. Vaishnavi Travels team was very helpful throughout.",
    rating: 5,
    style: "style-2",
  }
];

































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Urbania on Rent",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-mumbai-urbania-rental.jpg",
  "description": "Book 13 or 17 seater Force Urbania on rent from Pune to Mumbai with Vaishnavi Travels. Ideal for family trips, corporate travel, weekend getaways, and airport drops. AC Urbania van with driver included.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.85",
    "ratingCount": "523"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4800",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-mumbai-urbania-on-rent"
  }
};




  return (
    <div>


<Helmet>
  <title>Pune to Mumbai Urbania on Rent | 13 & 17 Seater AC Vans | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book 13 or 17 seater Force Urbania on rent from Pune to Mumbai with Vaishnavi Travels. Ideal for family trips, corporate travel, weekend getaways, and airport drops. AC Urbania van with driver included."
  />
  <meta
    name="keywords"
    content="Urbania Hire Pune to Mumbai, Force Urbania for Mumbai Trip, 13/17 Seater Urbania Pune-Mumbai, Outstation Urbania Pune to Mumbai, Corporate Urbania Pune to Mumbai, Pune to Mumbai Family Trip Urbania, Urbania Booking Pune for Mumbai Darshan, AC Urbania Travel Pune to Mumbai, Weekend Trip Urbania Van, Pune to Mumbai Luxury Urbania Van, Mumbai Airport Drop Urbania Pune, Urbania Van for Mumbai Tour, Pune-Mumbai Highway Urbania Rental"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/40.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiurbaniaonrent;